var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "装卸队动账调整",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onHandleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "contents" },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.dialogLoading,
                      expression: "dialogLoading",
                    },
                  ],
                  ref: "refCityForm",
                  staticClass: "demo-cityForm",
                  attrs: {
                    "label-width": "170px",
                    model: _vm.cityForm,
                    rules: _vm.cityRules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择装卸队", prop: "fleet_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "选择装卸队" },
                          model: {
                            value: _vm.cityForm.fleet_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.cityForm, "fleet_id", $$v)
                            },
                            expression: "cityForm.fleet_id",
                          },
                        },
                        _vm._l(_vm.Filterdata2, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.fleetName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "类型", prop: "flow_type" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "请选择类型" },
                          on: { change: _vm.typechange },
                          model: {
                            value: _vm.cityForm.flow_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.cityForm, "flow_type", $$v)
                            },
                            expression: "cityForm.flow_type",
                          },
                        },
                        _vm._l(_vm.Filterdata1, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "调整金额", prop: "amount" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入差异调整金额",
                          clearable: "",
                        },
                        model: {
                          value: _vm.cityForm.amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.cityForm, "amount", $$v)
                          },
                          expression: "cityForm.amount",
                        },
                      }),
                      _vm.cityForm.flow_type == 21 ||
                      _vm.cityForm.flow_type == 22
                        ? _c("div", { staticStyle: { color: "red" } }, [
                            _vm._v(
                              " 请输入正整数，审核通过后将从装卸队扣除该金额 "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "转账时间", prop: "transfer_time" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetime",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: "转账时间",
                        },
                        model: {
                          value: _vm.cityForm.transfer_time,
                          callback: function ($$v) {
                            _vm.$set(_vm.cityForm, "transfer_time", $$v)
                          },
                          expression: "cityForm.transfer_time",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "转帐记录", prop: "transfer_img" } },
                    [
                      _c(
                        "el-upload",
                        {
                          class: { hide: _vm.transfer_img.length == 1 },
                          attrs: {
                            "element-loading-text": "正在上传...",
                            action: "#",
                            "on-preview": _vm.handlePictureCardPreview,
                            "file-list": _vm.transfer_img,
                            "list-type": "picture-card",
                            "http-request": (file) => {
                              return _vm.uploadFile(file, "transfer_img")
                            },
                            "before-remove": (file, fileList) => {
                              return _vm.deleteFile(
                                file,
                                fileList,
                                "transfer_img"
                              )
                            },
                            limit: 1,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-plus",
                            attrs: { slot: "trigger" },
                            slot: "trigger",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户备注", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          placeholder: "请输入备注",
                          maxlength: "50",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.cityForm.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.cityForm, "remark", $$v)
                          },
                          expression: "cityForm.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.onHandleSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }